import { $api } from '../y/api';
import { $http } from '../y/http';

export type XTaskStatus = 'pending' | 'resolved' | 'rejected';

export interface XTaskProgress {
    total: number;
    step: number;
    step_max: number;
    step_name: string;
    item: number;
    item_max: number;
    item_name: string;
}

interface TaskResolvedResponse<T> {
    status: 'resolved';
    response: T;
}

interface TaskRejectedResponse {
    status: 'rejected';
    response: {
        code: number;
        message: string;
    };
}

interface TaskProgressResponse {
    status: 'pending';
    progress: XTaskProgress;
}

type TaskResponse<T> = TaskResolvedResponse<T> | TaskRejectedResponse | TaskProgressResponse;

export function xTaskWait<T>(task: string, progress?: (p: XTaskProgress) => void, timeout: number = 1) {
    return new Promise<T>((resolve, reject) => {
        const poll = () => {
            $api.GET<TaskResponse<T>>(`task/${task}/response`).then(r => {
                if(r.status == 'pending') {
                    progress?.(r.progress);
                    setTimeout(poll, 1000 * timeout);
                } else if(r.status == 'rejected') {
                    reject(r.response.message);
                } else if(r.status == 'resolved') {
                    resolve(r.response);
                } else {
                    reject('Invalid response from task waiter');
                }
            });
        };
        poll();
    });
}

export function xTaskTest() {
    return $http.POST<{ task: string }>(`/service/ticket/v1/test_task`).catch($api.errorHandler);
}

